// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'payback', 'payback Fallback'"},"className":"__className_992849","variable":"__variable_992849"};